<style>
</style>

<template>
<v-row dense>
  <v-col cols="12">
    <div class="font-weight-bold">{{ $t('Sumář objednávky') }}</div>
  </v-col>
  <v-col cols="7" class="text-left">
    <div class="body-2 grey--text">{{ $t('Za zboží a služby') }}</div>
    <div class="body-2 grey--text">{{ $t('DHP') }}</div>
    <div class="font-weight-bold grey--text">{{ $t('Celkem') }}</div>
    <div class="body-2 grey--text">{{ $t('Použitý kredit') }}</div>
    <div class="body-2 grey--text" v-if="deliveryPrice > 0">{{ $t('Za doručení') }}</div>
    <div class="body-2 grey--text" v-if="totalDiscount > 0">{{ $t('Sleva') }}</div>
    <div class="font-weight-bold grey--text">{{ $t('Cena k úhradě') }}</div>
  </v-col>
  <v-col cols="5" class="text-right">
    <div class="body-2 grey--text">{{ nettoFullTotalPrice | currency }}</div>
    <div class="body-2 grey--text">{{ totalVat | currency }}</div>
    <div class="font-weight-bold grey--text">{{ fullTotalPrice | currency }}</div>
    <div class="body-2 grey--text">{{ -totalCredit | currency }}</div>
    <div class="body-2 grey--text" v-if="deliveryPrice > 0">{{ deliveryPrice | currency }}</div>
    <div class="body-2 grey--text" v-if="totalDiscount > 0">{{ -totalDiscount | currency }}</div>
    <div class="font-weight-bold grey--text">{{ totalPriceToPay | currency }}</div>
  </v-col>
  <v-col cols="12" mt-5 class="text-left">
    <payment-reduction></payment-reduction>
  </v-col>
</v-row>
</template>

<script>
import BasketMixin from '@/mixins/basket-mixin.js'
import TransfromMixin from '@gravela/vue-component-library/src/mixins/transform-mixin.js'
import PaymentReduction from '../components/payment-reduction.vue'

export default {
  props: {
    value: {
      type: Array
    }
  },
  data() {
    return {
      headers: [{
        text: 'Popis',
        value: 'desc',
        sortable: false
      }, {
        text: 'Cena',
        value: 'amount',
        align: 'right',
        sortable: false
      }],
      reduction: false
    }
  },
  mixins: [BasketMixin, TransfromMixin],
  components: {
    'payment-reduction': PaymentReduction
  },
  computed: {
    items() {
      return [{
        desc: this.transform('Za zboží a služby'),
        amount: this.noVatTotalPrice
      }, {
        desc: this.transform('DPH'),
        amount: this.totalVat
      }]
    }
  }
}
</script>
